/* ==========================================================================
   KCLAUNCH — bannerslideshow en afteller

   Twee losse stukken in één bestand, want ze staan altijd samen op dezelfde
   pagina en twee verzoeken voor samen een paar kilobyte is zonde.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__kclInit) return;
  window.__kclInit = true;

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Bannerslideshow ----------

     De baan is een gewone scrollcontainer met scroll-snap. Dit script doet
     daar drie dingen bovenop: de stipjes bijhouden, de pijlen bedienen en
     eventueel automatisch doorschuiven. Welke slide in beeld staat wordt niet
     uitgerekend uit scrollLeft maar gemeten met een IntersectionObserver, want
     bij een snap-animatie klopt scrollLeft onderweg niet met wat je ziet. */

  function initHero(root) {
    var slideshows = root.querySelectorAll('[data-kcl-slideshow]');

    Array.prototype.forEach.call(slideshows, function (el) {
      if (el.dataset.kclReady === '1') return;
      el.dataset.kclReady = '1';

      var track = el.querySelector('[data-kcl-track]');
      var slides = track ? Array.prototype.slice.call(track.children) : [];
      if (!track || slides.length < 2) return;

      var dots = Array.prototype.slice.call(el.querySelectorAll('[data-kcl-dot]'));
      var prev = el.querySelector('[data-kcl-prev]');
      var next = el.querySelector('[data-kcl-next]');
      var index = 0;

      function paint() {
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }

      function goTo(i, smooth) {
        var target = slides[Math.max(0, Math.min(i, slides.length - 1))];
        if (!target) return;
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: smooth && !reduceMotion ? 'smooth' : 'auto'
        });
      }

      if (window.IntersectionObserver) {
        var seen = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var i = slides.indexOf(entry.target);
            if (i > -1 && i !== index) {
              index = i;
              paint();
            }
          });
        }, { root: track, threshold: 0.6 });

        slides.forEach(function (slide) { seen.observe(slide); });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i, true); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); });
      if (next) next.addEventListener('click', function () { goTo(index + 1, true); });

      paint();

      /* Automatisch doorschuiven. Niet bij beperkte beweging, en niet zolang
         de bezoeker met de banner bezig is: hover, focus of een vinger erop.
         Ook stil wanneer het tabblad op de achtergrond staat, anders staat de
         banner bij terugkomst tien slides verder. */

      var ms = parseInt(el.dataset.kclAutoplay, 10) || 0;
      if (!ms || reduceMotion) return;

      var timer = null;
      var frozen = 0;

      function tick() {
        if (frozen || document.hidden) return;
        goTo(index >= slides.length - 1 ? 0 : index + 1, true);
      }

      function start() {
        if (timer) return;
        timer = window.setInterval(tick, ms);
      }

      function freeze() { frozen += 1; }
      function thaw() { frozen = Math.max(0, frozen - 1); }

      el.addEventListener('mouseenter', freeze);
      el.addEventListener('mouseleave', thaw);
      el.addEventListener('focusin', freeze);
      el.addEventListener('focusout', thaw);
      track.addEventListener('pointerdown', freeze);
      window.addEventListener('pointerup', thaw);

      start();
    });
  }

  /* ---------- Afteller ----------

     Liquid levert het launchmoment als Unix-tijd in data-kcl-deadline. Dat is
     bewust een absoluut getal en geen datumtekst: een datum zonder tijdzone
     leest een browser in Amsterdam anders dan een browser in Londen, en dan
     telt de helft van de bezoekers naar het verkeerde moment af.

     De klok loopt op één interval voor alle tellers op de pagina, zodat de
     grote teller en de vastgezette balk nooit een seconde uit elkaar lopen. */

  var clocks = [];
  var ticking = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Elke teller heeft zijn eigen cijfervakjes. De grote teller en de
     vastgezette balk tonen dezelfde deadline, maar het zijn twee stukken DOM
     en ze moeten dus allebei bijgewerkt worden. */

  function render(clock, left) {
    var d = Math.floor(left / 86400);
    var h = Math.floor((left % 86400) / 3600);
    var m = Math.floor((left % 3600) / 60);
    var s = Math.floor(left % 60);

    clock.faces.forEach(function (face) {
      if (face.day) face.day.textContent = String(d);
      if (face.hour) face.hour.textContent = pad(h);
      if (face.minute) face.minute.textContent = pad(m);
      if (face.second) face.second.textContent = pad(s);
    });
  }

  /* Eén keer herladen zodra de teller op nul komt, zodat de pagina de nieuwe
     staat van de producten ophaalt. De vlag in sessionStorage is geen luxe:
     zonder die vlag blijft de pagina herladen als het metafield niet wordt
     bijgewerkt, want na de herlading staat de deadline nog steeds in het
     verleden. Shopify zet bovendien een korte cache op collectiepagina's,
     dus de eerste herlading kan nog de oude pagina opleveren. */

  function reloadOnce(key) {
    try {
      if (window.sessionStorage.getItem(key) === '1') return;
      window.sessionStorage.setItem(key, '1');
    } catch (e) {
      /* Privémodus zonder opslag: dan liever niet herladen dan in een lus
         belanden. */
      return;
    }
    window.location.reload();
  }

  function finish(clock) {
    clock.done = true;
    clock.faces.forEach(function (face) { face.el.hidden = true; });
    if (clock.reloadKey) reloadOnce(clock.reloadKey);
  }

  function tickAll() {
    var now = Math.floor(Date.now() / 1000);
    var live = 0;

    clocks.forEach(function (clock) {
      if (clock.done) return;
      var left = clock.deadline - now;
      if (left <= 0) {
        finish(clock);
        return;
      }
      render(clock, left);
      live += 1;
    });

    if (!live && ticking) {
      window.clearInterval(ticking);
      ticking = null;
    }
  }

  function initCountdown(root) {
    var els = root.querySelectorAll('[data-kcl-deadline]');

    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.kclReady === '1') return;
      el.dataset.kclReady = '1';

      var deadline = parseInt(el.dataset.kclDeadline, 10);
      if (!deadline) return;

      /* De grote teller en de vastgezette kopie horen bij dezelfde deadline en
         moeten samen verdwijnen, dus ze delen één klok. */
      var group = el.dataset.kclGroup || String(deadline);
      var clock = null;

      for (var i = 0; i < clocks.length; i += 1) {
        if (clocks[i].group === group) { clock = clocks[i]; break; }
      }

      if (!clock) {
        clock = {
          group: group,
          deadline: deadline,
          faces: [],
          done: false,
          reloadKey: 'kcl-reloaded-' + group
        };
        clocks.push(clock);
      }

      clock.faces.push({
        el: el,
        day: el.querySelector('[data-kcl-d]'),
        hour: el.querySelector('[data-kcl-h]'),
        minute: el.querySelector('[data-kcl-m]'),
        second: el.querySelector('[data-kcl-s]')
      });

      el.dataset.kclState = 'running';
    });

    if (!clocks.length) return;

    tickAll();
    if (!ticking) ticking = window.setInterval(tickAll, 1000);
  }

  /* ---------- Vastgezette balk ----------

     Verschijnt zodra de echte teller uit beeld is. Met een IntersectionObserver
     en niet met een scroll-listener, want dat laatste rekent bij elke pixel. */

  function initSticky(root) {
    var bars = root.querySelectorAll('[data-kcl-sticky-for]');

    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.dataset.kclReady === '1') return;
      bar.dataset.kclReady = '1';

      var anchor = document.getElementById(bar.dataset.kclStickyFor);
      if (!anchor || !window.IntersectionObserver) return;

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.dataset.kclVisible = entry.isIntersecting ? '0' : '1';
        });
      }, { threshold: 0 }).observe(anchor);
    });
  }

  function init(root) {
    var scope = root || document;
    initHero(scope);
    initCountdown(scope);
    initSticky(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* De theme editor vervangt losse secties zonder de pagina te herladen. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
